import React from 'react';
import { Box, BoxProps, IconButton, IconButtonProps, Stack, StackProps, styled } from '@mui/material';
import { FullScreen, FullScreenProps, useFullScreenHandle } from 'react-full-screen';
import { isMobile,  } from 'react-device-detect';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';

const BorderedBox = styled(Box)<BoxProps>(({ theme }) => ({
  borderWidth: 1,
  borderColor: theme.palette.grey[400],
  borderStyle: 'solid',
  position: 'relative',
}));

const ScrollableFullScreen = styled(FullScreen)<FullScreenProps>(() => ({
  overflow: 'auto',
  display: 'flex',
  alignItems:'center'
}));

const ZoomIconButton = styled(IconButton)<IconButtonProps>(({ theme }) => ({
  color: 'white',
  fontSize: theme.typography.h1.fontSize,
  backgroundColor: theme.palette.action.disabled,
  '&:hover' : {
    backgroundColor: theme.palette.action.active,
  }
}));

const AbsoluteStack = styled(Stack)<StackProps>(() => ({
  position: 'absolute',
  height: '100%',
  width: '100%',
  top: 0
}));

interface MobileZoomImageProps extends BoxProps {
  src: string,
}

export const MobileZoomImage: React.FC<MobileZoomImageProps> = ({src, ...boxProps}) => {
  const handle = useFullScreenHandle();

  const handleImageOnClick = () => {
    if(!handle.active && isMobile) {
      handle.enter();
    }
  };

  return(
    <BorderedBox {...boxProps} >
      <ScrollableFullScreen handle={handle}>
        {handle.active && (
          <AbsoluteStack flexDirection='row' alignItems='center' justifyContent='center' flexGrow={1} >
            <ZoomIconButton onClick={handle.exit} style={{position:'fixed'}}><ZoomOutIcon fontSize='inherit' /></ZoomIconButton>
          </AbsoluteStack>
        )}
        <img src={src} style={{margin: 'auto'}} width={handle.active ? undefined : '100%'} onClick={handleImageOnClick}/>
      </ScrollableFullScreen>
      {isMobile && (
        <AbsoluteStack alignItems='center' justifyContent='center' flexGrow={1} onClick={handleImageOnClick}>
          <ZoomIconButton><ZoomInIcon fontSize='inherit' /></ZoomIconButton>
        </AbsoluteStack>
      )}
    </BorderedBox>
  );
};